import { MinimizeIcon, CloseIcon, ChevronLeftIcon } from './Icons.jsx';

/**
 * Status line reflects what is actually true: the socket state and the rota —
 * not a decorative "we're online".
 *
 * It used to have a fourth state for a live agent alert. That is gone: an
 * alert is something the agent side can see about a conversation, and the
 * visitor's header should not announce a distinction they were never told
 * about in the first place.
 */
function statusOf({ connection, offline }) {
  if (offline) return { text: 'Offline · replies by email', dot: 'var(--sc-tx3)' };
  if (connection === 'connected') return { text: 'Online · typically replies in minutes', dot: 'var(--sc-ok)' };
  if (connection === 'disconnected') return { text: 'Reconnecting…', dot: 'var(--sc-warn)' };
  return { text: 'Connecting…', dot: 'var(--sc-tx3)' };
}

export function Header({
  brand,
  initial,
  connection,
  offline,
  onClose,
  onMinimize,
  onBack,
}) {
  const status = statusOf({ connection, offline });

  return (
    <div class="header">
      {onBack ? (
        <button class="header__action" type="button" onClick={onBack} aria-label="Back">
          <ChevronLeftIcon size={16} />
        </button>
      ) : (
        <div class="header__mark" aria-hidden="true">
          {initial}
        </div>
      )}

      <div class="header__text">
        <div class="header__brand">{brand}</div>
        <div class="header__status">
          <span class="header__dot" style={{ background: status.dot }} />
          {status.text}
        </div>
      </div>

      <button class="header__action" type="button" onClick={onMinimize} aria-label="Minimize">
        <MinimizeIcon size={16} />
      </button>
      <button class="header__action" type="button" onClick={onClose} aria-label="Close chat">
        <CloseIcon size={16} />
      </button>
    </div>
  );
}

export default Header;
